import { useEffect, useState } from "react";
import ViewGroupComponent from "../../../Comp/Group/ViewGroup/ViewGroup";
import { toast } from "react-toastify";
import useStore from "../../../Hooks/useStore";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import { useCallback } from "react";

const ViewGroup = () => {
  const axiosPrivate = useAxiosPrivate();
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const { fetchAgain } = useStore();

  let FETCH_TABLE_URL = `/api/deals/showappdealsgroup?page=${page + 1}&limit=${rowsPerPage}`;
  if (searchTerm && searchTerm.trim() !== "") {
    FETCH_TABLE_URL += `&searchTerm=${encodeURIComponent(searchTerm)}`;
  }

  const fetchData = useCallback(async (controller) => {
    setLoading(true);
    try {
      const response = await axiosPrivate.get(FETCH_TABLE_URL, {
        signal: controller.signal,
      });
      const modifidedData = await response.data.data


      setTableData(modifidedData);
      console.log("Group Data", response?.data.totalCount);
      setTotalCount(response?.data?.totalCount);
    } catch (error) {
      console.log(error.message);
      toast(error?.response?.data.error);
    } finally {
      setLoading(false);
    }
  },[FETCH_TABLE_URL,axiosPrivate]);
  useEffect(() => {
    const controller = new AbortController();

    
    fetchData(controller);

    return () => {
      controller.abort();
    };
  }, [fetchAgain, rowsPerPage, page, fetchData]);

  return (
    <ViewGroupComponent
      
      tableData={tableData}
      loading={loading}
      setSearchTerm={setSearchTerm}
      totalCount={totalCount}
      setPage={setPage}
      page={page}
      rowsPerPage={rowsPerPage}
      setRowsPerPage={setRowsPerPage}
      searchTerm={searchTerm}

    />
  );
};
export default ViewGroup;
